var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E7F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7049 24.2398L26.5799 17.3648M19.7049 24.6982V26.7396C19.7049 28.9158 19.7049 30.0029 20.3558 30.1771C21.0066 30.3513 21.6923 29.4456 23.0636 27.6352L23.8299 26.5315M18.3373 17.5289L25.0482 14.3573C27.8367 13.0391 29.2309 12.38 30.1201 13.0409C31.0093 13.7018 30.7553 15.2088 30.2466 18.2219L29.3721 23.4121C29.0393 25.382 28.8734 26.3665 28.1392 26.7964C27.4049 27.2263 26.4507 26.8963 24.5431 26.2363L18.7085 24.2178C15.1408 22.984 13.357 22.3671 13.291 21.1562C13.2232 19.9462 14.9282 19.1395 18.3373 17.5289Z",
    stroke: "#06AED4",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/Sent-icon.4c190c256e9896ecd2e966597601e7c1.svg";
export { ForwardRef as ReactComponent };